/* Louise Donut's — interactions */
(() => {
  // --- Active nav link based on current page ---
  const path = location.pathname.split('/').pop() || 'index.html';
  document.querySelectorAll('.site-header__nav a').forEach(a => {
    const href = a.getAttribute('href');
    a.classList.toggle('is-active', href === path);
  });

  // --- Mobile nav toggle ---
  const toggle = document.getElementById('navToggle');
  const nav = document.getElementById('nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => nav.classList.toggle('is-open'));
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => nav.classList.remove('is-open')));
  }

  // --- Reveal on scroll ---
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-in'));
  }

  // --- Split hero + topbar reveal ---
  const se = document.getElementById('scrollExpand');
  const seLeft = document.getElementById('seLeft');
  const seRight = document.getElementById('seRight');
  const seCue = document.getElementById('seCue');
  const seVideo = document.getElementById('seVideo');
  const topbar = document.getElementById('topbar');

  // Topbar visible immédiatement (le scroll-expand a été retiré sur la home)
  if (topbar) topbar.classList.add('is-visible');

  if (se && seLeft && seRight) {
    if (seVideo) { const tryPlay = () => seVideo.play().catch(() => {}); seVideo.addEventListener('canplay', tryPlay); tryPlay(); }

    const onScroll = () => {
      const rect = se.getBoundingClientRect();
      const total = rect.height - innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      const progress = total > 0 ? scrolled / total : 0;

      // Split completes at 85% of section scroll; last 15% is "video coast" before the topbar slides in
      const splitProgress = Math.min(progress / 0.85, 1);
      const offset = splitProgress * 100;
      seLeft.style.transform = `translateX(${-offset}%)`;
      seRight.style.transform = `translateX(${offset}%)`;
      if (seCue) seCue.style.opacity = String(Math.max(0, 1 - splitProgress * 2));

      // Topbar slides in from above once the split is fully done
      if (topbar) topbar.classList.toggle('is-visible', splitProgress >= 1);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (reduced) {
      seLeft.style.transform = 'translateX(-100%)';
      seRight.style.transform = 'translateX(100%)';
      if (seCue) seCue.style.opacity = '0';
      if (topbar) topbar.classList.add('is-visible');
    }
  } else if (topbar) {
    // No scroll-expand on this page (inner pages) — topbar visible from the start
    topbar.classList.add('is-visible');
  }

  // --- Menu page tabs ---
  document.querySelectorAll('.menu-tabs').forEach(tabs => {
    const buttons = tabs.querySelectorAll('.menu-tab');
    buttons.forEach(btn => btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      buttons.forEach(b => b.classList.toggle('is-active', b === btn));
      document.querySelectorAll('.menu-category').forEach(cat => {
        cat.style.display = (target === 'all' || cat.dataset.cat === target) ? '' : 'none';
      });
    }));
  });

  // --- Boutique hours tabs (switch which boutique's schedule is shown) ---
  document.querySelectorAll('.hours-tabs').forEach(tabs => {
    const buttons = tabs.querySelectorAll('.hours-tab');
    buttons.forEach(btn => btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      buttons.forEach(b => b.classList.toggle('is-active', b === btn));
      document.querySelectorAll('.hours-panel').forEach(p => {
        p.classList.toggle('is-active', p.dataset.panel === target);
      });
    }));
  });

  // --- Menu item photo cards: click photo to open lightbox ---
  document.querySelectorAll('.menu-item--with-photo .menu-item__photo').forEach(photo => {
    photo.style.cursor = 'zoom-in';
    photo.addEventListener('click', (e) => {
      e.stopPropagation();
      const img = photo.querySelector('img');
      if (!img) return;
      const src = img.src.replace(/width=\d+/, 'width=1200');
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(58,31,26,.7);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;cursor:zoom-out;animation:cd-fade .2s ease';
      const big = document.createElement('img');
      big.src = src;
      big.style.cssText = 'max-width:90vw;max-height:85vh;border-radius:20px;box-shadow:0 20px 60px rgba(0,0,0,.4)';
      overlay.appendChild(big);
      overlay.addEventListener('click', () => overlay.remove());
      document.body.appendChild(overlay);
    });
  });

  // --- Tea flavor pills (simple click-to-toggle, single-select per group) ---
  document.querySelectorAll('.tea-flavors').forEach(group => {
    group.querySelectorAll('span').forEach(pill => {
      pill.addEventListener('click', () => {
        const wasActive = pill.classList.contains('is-selected');
        group.querySelectorAll('span').forEach(p => p.classList.remove('is-selected'));
        if (!wasActive) pill.classList.add('is-selected');
      });
    });
  });

  // --- Flavor picker (click a flavor pill → photo + name update) ---
  document.querySelectorAll('.flavor-picker').forEach(picker => {
    const media = picker.querySelector('.flavor-picker__media');
    const img = media ? media.querySelector('img') : null;
    const nameEl = picker.querySelector('.flavor-picker__name span');
    const pills = picker.querySelectorAll('.flavor');

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('is-active')) return;
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        const newImg = pill.dataset.img;
        const newName = pill.dataset.name || pill.textContent.trim();
        if (img && newImg) {
          media.classList.add('is-changing');
          setTimeout(() => {
            img.src = newImg;
            img.alt = newName;
            media.classList.remove('is-changing');
          }, 200);
        }
        if (nameEl) nameEl.textContent = newName;
      });
    });
  });

  // --- Interactive builders (Bubble Waffle + Bubble Tea, same structure) ---
  document.querySelectorAll('.bw-builder').forEach(bw => {
    const totalEl = bw.querySelector('[data-bw-total]');
    const recompute = () => {
      let total = 0;
      bw.querySelectorAll('.bw-step.is-active').forEach(step => {
        total += parseFloat(step.dataset.price || '0');
      });
      if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
    };

    bw.querySelectorAll('.bw-step').forEach(step => {
      const header = step.querySelector('.bw-step__header');
      if (!header) return;
      header.addEventListener('click', () => {
        if (step.dataset.locked === 'true') return;
        step.classList.toggle('is-active');
        recompute();
      });
    });

    const preview = bw.querySelector('.bw-preview');
    const previewMedia = preview ? preview.querySelector('.bw-preview__media') : null;
    const previewImg = previewMedia ? previewMedia.querySelector('img') : null;
    const previewNameEl = preview ? preview.querySelector('.bw-preview__name span') : null;
    const defaultImg = previewImg ? previewImg.getAttribute('src') : null;
    const defaultName = previewNameEl ? previewNameEl.textContent : '';

    // Compose the preview name + photo from the current selections (sirop + perle for bubble tea).
    const updatePreview = () => {
      if (!preview) return;
      let sirop = null, perle = null;
      bw.querySelectorAll('.bw-step[data-bw-category]').forEach(step => {
        const cat = step.dataset.bwCategory;
        const sel = step.querySelector('.bw-option.is-selected');
        if (!sel) return;
        if (cat === 'sirop') sirop = sel;
        else if (cat === 'perle') perle = sel;
      });

      let name = defaultName;
      if (sirop && perle) {
        name = `${sirop.textContent.trim()} & perles ${perle.textContent.trim()}`;
      } else if (sirop) {
        name = sirop.textContent.trim();
      } else if (perle) {
        name = `Perles ${perle.textContent.trim()}`;
      }

      // Photo priority: sirop wins (since it defines the drink's color); else perle; else default
      const newImg = (sirop && sirop.dataset.img) || (perle && perle.dataset.img) || defaultImg;

      if (previewImg && newImg && previewImg.getAttribute('src') !== newImg) {
        previewMedia.classList.add('is-changing');
        setTimeout(() => {
          previewImg.src = newImg;
          previewImg.alt = name;
          previewMedia.classList.remove('is-changing');
        }, 200);
      }
      if (previewNameEl) previewNameEl.textContent = name;
    };

    bw.querySelectorAll('.bw-option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        const step = opt.closest('.bw-step');
        if (step && step.dataset.single === 'true') {
          const wasActive = opt.classList.contains('is-selected');
          step.querySelectorAll('.bw-option').forEach(o => o.classList.remove('is-selected'));
          if (!wasActive) opt.classList.add('is-selected');
        } else {
          opt.classList.toggle('is-selected');
        }
        updatePreview();
      });
    });

    const reset = bw.querySelector('[data-bw-reset]');
    if (reset) {
      reset.addEventListener('click', () => {
        bw.querySelectorAll('.bw-step').forEach(step => {
          if (step.dataset.locked !== 'true') step.classList.remove('is-active');
        });
        bw.querySelectorAll('.bw-option.is-selected').forEach(o => o.classList.remove('is-selected'));
        recompute();
        if (preview) {
          if (previewImg && defaultImg) previewImg.src = defaultImg;
          if (previewNameEl) previewNameEl.textContent = defaultName;
        }
      });
    }
    recompute();
  });

  // --- Contact form (front-end only feedback) ---
  const form = document.getElementById('contactForm');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      form.style.display = 'none';
      const ok = document.getElementById('contactOk');
      if (ok) ok.style.display = 'block';
    });
  }
})();

/* === Délégation événements (remplace les onclick inline pour CSP/SEO) === */
(function () {
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      return;
    }
    const facetClose = e.target.closest('[data-mobile-facets-close]');
    if (facetClose) {
      const wrap = facetClose.closest('.mobile-facets__wrapper');
      const summary = wrap && wrap.querySelector('summary');
      if (summary) summary.click();
      return;
    }
    const selectable = e.target.closest('[data-select-on-click]');
    if (selectable && typeof selectable.select === 'function') selectable.select();
  });
})();
